import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import './loading-indicator.scss';

export function LoadingIndicator() {
  return (
    <div className='loading-indicator'>
      <CircularProgress size={75} />
    </div>
  );
}
